module.exports = __webpack_public_path__ + "img/49.910fd13c.png";